/* eslint-disable */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class DeleteTrashIcon extends BaseIcon {
  getChildren = () => [ <path d="M4 6h9v10H4zM13 5h1V3h-3V1H6v2H3v2h10zM7 2h3v1H7V2z" fill={this.getColor()}/> ]
  getViewBox = () => '0 0 16 16'
}
